<template>
  <div class="relative select-none">
    <nav class="flex flex-wrap items-center justify-between px-2 bg-white dark:bg-stone-800 shadow-md">
      <!-- Brand section -->
      <div class="navbar-brand">
        <button @click="goBackToMainPage"
          class="navbar-item flex items-center text-stone-800 dark:text-stone-100">
          <img src="/images/favicon-32x32.png" class="inline-block mr-3" alt="Spin the Names Logo" />
          <span class="font-cutedino text-2xl mt-1">Spin the Names!</span>
        </button>
      </div>

      <!-- End items -->
      <div class="flex items-center">
        <!-- Feedback button removed -->
      </div>
    </nav>
    <AnnouncementBanner />
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import * as Util from '@utils/Util.js';
import { i18n } from '@/i18n-setup.js';
import AnnouncementBanner from '@components/ui/AnnouncementBanner.vue';

const router = useRouter();

function goBackToMainPage() {
  router.push(`/${Util.getNonEnglishLocale(i18n.global.locale.value)}`);
}
</script>

<style>
.navbar-brand {
  @apply flex items-center mr-6;
}

.navbar-item {
  @apply px-2 text-stone-700 dark:text-stone-200 hover:text-primary-500 dark:hover:text-primary-400 transition-all;
}
</style>
